var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBankAccountInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M29.3334 12V21.9467C29.3334 25 26.8534 27.4667 23.8 27.4667H8.20002C5.14669 27.4667 2.66669 25 2.66669 21.9467V12H29.3334Z",
    fill: "#1577DA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3334 10.0534V12.0001H2.66669V10.0534C2.66669 7.00005 5.14669 4.53339 8.20002 4.53339H23.8C26.8534 4.53339 29.3334 7.00005 29.3334 10.0534Z",
    fill: "#1577DA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 23H8C7.45333 23 7 22.5467 7 22C7 21.4533 7.45333 21 8 21H10.6667C11.2133 21 11.6667 21.4533 11.6667 22C11.6667 22.5467 11.2133 23 10.6667 23Z",
    fill: "#1577DA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3333 23H14C13.4533 23 13 22.5467 13 22C13 21.4533 13.4533 21 14 21H19.3333C19.88 21 20.3333 21.4533 20.3333 22C20.3333 22.5467 19.88 23 19.3333 23Z",
    fill: "#1577DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankAccountInfo);
export default __webpack_public_path__ + "static/media/BankAccountInfo.886f82b1ca994070fe164e2f62897994.svg";
export { ForwardRef as ReactComponent };